import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./baseQuery";

// Dummy API (JSONPlaceholder)
const apiUrl = process.env.REACT_APP_API_URL;
export const cartApi = createApi({
  reducerPath: "cartApi", // optional, defaults to 'api'
  baseQuery: customBaseQuery,
  tagTypes: ["cartList"],
  endpoints: (builder) => ({
    addItemToCart: builder.mutation({
      query: (data) => {
        return {
          url: `/inventory/add-to-cart`,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["cartList"], // GET /posts
    }),
    removeItemFromCart: builder.mutation({
      query: (data) => {
        return {
          url: `/inventory/cart`,
          method: "DELETE",
          body: data,
        };
      },
      invalidatesTags: ["cartList"], // GET /posts
    }),
    getCartItems: builder.query({
      query: () => {
        return {
          url: "/inventory/cart",
          method: "GET",
        };
      },
      transformResponse: (res) => {
        return res.data;
      },
      providesTags: ["cartList"],
    }),
    sendInquiry: builder.mutation({
      query: () => {
        return {
          url: "/inventory/send/inquiry",
          method: "POST",
        };
      },
      invalidatesTags: ["cartList"],
    }),
    getSingleInquiry: builder.query({
      query: (id) => {
        return {
          url: `/user/inquiry/summary?inquiryId=${id}`,
          method: "GET",
        };
      },
      transformResponse: (res) => {
        return res?.data;
      },
    }),
  }),
});

export const {
  useAddItemToCartMutation,
  useRemoveItemFromCartMutation,
  useGetCartItemsQuery,
  useSendInquiryMutation,
  useGetSingleInquiryQuery,
} = cartApi;
